module.exports = __webpack_public_path__ + "static/media/timer.a2fb9a5e.png";